import React from "react";
import { ReactComponent as IconDown } from "../../assets/newImages/icons/downDash.svg";
import { ReactComponent as IconUp } from "../../assets/newImages/icons/upDash.svg";
import { TagDownCard, TagUpCard } from "../../pages/Metricas/styles";
import { useTheme } from "../../contexts/Theme/ThemeContext";

interface TagVariacaoProps {
  variacao: number;
}

export const TagVariacao: React.FC<TagVariacaoProps> = ({ variacao }) => {
  const { theme } = useTheme();
  const isPositiva = variacao >= 0;

  const TagComponent = isPositiva ? TagUpCard : TagDownCard;
  const Icon = isPositiva ? IconUp : IconDown;
  const className = isPositiva ? "destaqueUpCard" : "destaqueDownCard";

  return (
    <TagComponent theme={theme}>
      <span className={`${className} fonteRotulosCard`}>
        <Icon className="iconUpDown" />
        {isPositiva ? '+' : ''}{variacao.toFixed(1)}%
      </span>
    </TagComponent>
  );
};
